import styled from 'styled-components';

const OptionList = ({ data }: any) => {
  const filters = JSON.parse(data); // 객체로 변환

  // 배열 값을 문자열로 변환하고 합치기

  // // ✅ 추가할 값들을 배열로 구성
  const prefixValues = [
    filters?.type === 'a' ? '경매' : filters.type === 'p' ? '임대' : '',
    filters?.court,
    filters?.search2?.trim?.() ? filters.search2.trim() : '', // ✅ undefined 방지
  ].filter(Boolean); // 빈 문자열 제거
  // const prefixValues: any = [];

  const addPriceRange = (
    label: string,
    minKey: string,
    maxKey: string,
    unit: string,
  ) => {
    const minVal = filters[minKey]?.toString().trim();
    const maxVal = filters[maxKey]?.toString().trim();

    let value = `${label} `;

    if (minVal !== '0' && minVal) {
      value += `${minVal}${unit}`;
    }
    value += ' ~ ';

    if (maxVal !== '0' && maxVal) {
      value += `${maxVal}${unit}`;
    }

    if ((minVal !== '0' && minVal) || (maxVal !== '0' && maxVal)) {
      prefixValues.push(value);
    }
  };

  // ✅ 각 가격 유형 추가
  addPriceRange('최저가격', 'minBidPrice', 'maxBidPrice', '만원');
  addPriceRange('감정가격', 'minappraisedValue', 'maxappraisedValue', '만원');
  addPriceRange('건물면적', 'minconstructArea', 'maxconstructArea', '평');
  addPriceRange('토지면적', 'minlandArea', 'maxlandArea', '평');
  addPriceRange('사용승인', 'minApprovalDate', 'maxApprovalDate', '');
  addPriceRange('매각기일', 'minSaleDate', 'maxSaleDate', '');

  const excludeKeys = [
    'isCourtOrRegion',
    'search2',
    'type',
    'specialItemCond',
    'minappraisedValue',
    'maxappraisedValue',
    'minBidPrice',
    'maxBidPrice',
    'minconstructArea',
    'maxconstructArea',
    'minlandArea',
    'maxlandArea',
    'minSaleDate',
    'maxSaleDate',
    'minApprovalDate',
    'maxApprovalDate',
    'save_type',
    'search_type',
  ];
  const totalValue = Object.entries(filters)
    .filter(
      ([key, value]) =>
        !excludeKeys.includes(key) && // 특정 키 제외
        value !== 0 &&
        value !== '0' &&
        !(typeof value === 'string' && value.trim() === '') &&
        !(typeof value === 'string' && value.trim() === '0'),
    )
    .map(([_, value]) => {
      if (typeof value === 'string' && value.includes(',')) {
        const parts = value.split(',').filter(Boolean);
        if (parts.length >= 3) {
          return `${parts[0]} 외 ${parts.length - 1}개`;
        }
        return parts.join(', ');
      }

      return value;
    }); // 값만 추출

  // .join(', ');

  // console.log('totalValue', totalValue);
  const finalValue = [...prefixValues, ...totalValue]
    .filter(Boolean)
    .join(' | ');

  return <Options>{finalValue}</Options>;
};

export default OptionList;

const Options = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;

  display: -webkit-box;
  -webkit-line-clamp: 2; /* 최대 2줄 */
  -webkit-box-orient: vertical;

  overflow: hidden;
  text-overflow: ellipsis;

  font-weight: 400;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;
